// @flow
import { DURATION, EASING } from '../constants';
import styled, { keyframes } from 'styled-components';

const revealOpacity = keyframes`to { opacity: 1; }`;

export const Container = styled.div`
    animation: ${revealOpacity} ${DURATION} ${EASING} forwards;
    animation-delay: ${DURATION};
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
`;

export const Arrow = styled.div`
	border: solid ${p => p.arrowSize}px ${p => p.theme.mainBrandColor};
	border-bottom-width: 0;
	border-left-color: transparent;
	border-right-color: transparent
	position: absolute;
	transform: translate3d(-${p => p.arrowSize}px, -${p => p.arrowSize}px, 0);
	width: 0;
`;

export const TextContainer = styled.div`
    background-color: ${p => p.theme.mainBrandColor};
    border-radius: 2em;
    color: ${p => p.theme.white};
    padding: 0.3em 0.5em;
    text-align: center;
    transform: translate3d(${p => p.leftTranslation}%, -95%, 0);
`;



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/tooltip/style.js